import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';

const FirebaseDataCheck = () => {
  const [collections, setCollections] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const collectionsToCheck = [
    'menuItems',
    'products', 
    'orders',
    'users',
    'inventory',
    'shops',
    'links',
    'wholesale',
    'templates',
    'bookings',
    'waitingList',
    'contact'
  ];

  useEffect(() => {
    const fetchCollectionData = async () => {
      setLoading(true);
      const collectionsData = {};
      
      for (const collectionName of collectionsToCheck) {
        try {
          const querySnapshot = await getDocs(collection(db, collectionName));
          const docs = [];
          querySnapshot.forEach((doc) => {
            docs.push({ id: doc.id, ...doc.data() });
          });
          collectionsData[collectionName] = docs;
        } catch (error) {
          console.error(`Error fetching ${collectionName}:`, error);
          collectionsData[collectionName] = { error: error.message };
        }
      }
      
      setCollections(collectionsData);
      setLoading(false);
    };

    fetchCollectionData();
  }, []);

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading Firebase data...</div>;
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Firebase Data Check</h1>
      
      {Object.entries(collections).map(([collectionName, data]) => (
        <div key={collectionName} style={{ marginBottom: '30px', border: '1px solid #ccc', padding: '15px' }}>
          <h2>{collectionName}</h2>
          
          {data.error ? (
            <div style={{ color: 'red' }}>Error: {data.error}</div>
          ) : (
            <>
              <div style={{ marginBottom: '10px' }}>
                <strong>Document Count:</strong> {data.length}
              </div>
              
              {data.length > 0 && (
                <div>
                  <strong>Sample Document:</strong>
                  <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
                    {JSON.stringify(data[0], null, 2)}
                  </pre>
                </div>
              )}
              
              {data.length > 1 && (
                <div>
                  <strong>All Document IDs:</strong>
                  <div style={{ background: '#f9f9f9', padding: '10px', fontSize: '12px' }}>
                    {data.map(doc => doc.id).join(', ')}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default FirebaseDataCheck;